import { Outlet } from 'react-router-dom';

import { ROUTES } from 'constants/routes';

import DashboardLayout from '@layouts/dashboardLayout/Dashboard.layout';
import ChangeInformationPage from 'pages/system/manager/change-information';
import PreferencesPage from 'pages/system/preferences';
import ManagerPage from 'pages/system/manager';

export const SYSTEM_ROUTES = {
  path: ROUTES.SYSTEM.ROOT,
  element: <Outlet />,
  children: [
    {
      path: ROUTES.SYSTEM.PREFERENCES.path,
      element: (
        <DashboardLayout>
          <PreferencesPage />
        </DashboardLayout>
      ),
    },
    {
      path: ROUTES.SYSTEM.MANAGER.path,
      element: (
        <DashboardLayout>
          <ManagerPage />
        </DashboardLayout>
      ),
    },
    {
      path: `${ROUTES.SYSTEM.MANAGER.path}/change-information/:id`,
      element: (
        <DashboardLayout>
          <ChangeInformationPage />
        </DashboardLayout>
      ),
    },
  ],
};
